/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { TeamUserAssignmentDto } from './TeamUserAssignmentDto';
import type { UserPermissionAssignmentDto } from './UserPermissionAssignmentDto';

export type UpdateUserUiRequestDto = {
    authTypes: Array<'SAML2' | 'LOGIN_PASSWORD'>;
    domains?: Array<UserPermissionAssignmentDto>;
    isActive: boolean;
    name: string;
    role: UpdateUserUiRequestDto.role;
    teams?: Array<TeamUserAssignmentDto>;
};

export namespace UpdateUserUiRequestDto {

    export enum role {
        ADMIN = 'ADMIN',
        SYSTEM_EDITOR = 'SYSTEM_EDITOR',
        SYSTEM_VIEWER = 'SYSTEM_VIEWER',
    }


}
